import { isValidId } from '@nx-smartmonkey/shared/helpers';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import * as Routes from '../constants/Routing';

type Params = `projectId` | `planId`;

const paramsToLocations = {
  projectId: `/h/:projectId`,
  planId: Routes.PLANNER.PLAN_DETAILS.ROOT,
} as Record<Params, string>;

interface UseCustomParamsResponse {
  value: string | undefined;
}

interface UseCustomParamsProps {
  param: Params;
}

export const useCustomParams = ({ param }: UseCustomParamsProps): UseCustomParamsResponse => {
  const location = useLocation();

  const value = useMemo(() => {
    const pathSplit = location.pathname.split(`/`);
    const routeSplit = paramsToLocations[param].split(`/`);
    const paramValue = pathSplit[routeSplit.indexOf(`:${param}`)];

    return isValidId(paramValue) ? paramValue : undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return {
    value,
  };
};
